import { useCallback } from 'react';
import { StateSetter } from 'types/utils/React';
import SelectedButton from './SelectedButton';
import UnselectedButton from './UnselectedButton';

const getLabelId = (value: boolean) => (value ? 'yes' : 'no');

export type SwitchButtonProps = {
  currentValue: boolean;
  disabled: boolean;
  value: boolean;
  setValue: StateSetter<boolean>;
};

const SwitchButton = ({ currentValue, disabled, value, setValue } : SwitchButtonProps) : JSX.Element => {

  const onClick = useCallback(() => setValue(value), [value, setValue]);

  const labelId = getLabelId(value);

  if (currentValue === value) {
    return (
      <SelectedButton
        value={value}
        disabled={disabled}
        labelId={labelId}
        onClick={onClick}
      />
    );
  }

  return (
    <UnselectedButton
      value={value}
      disabled={disabled}
      labelId={labelId}
      onClick={onClick}
    />
  );
};

export default SwitchButton;
